import { hash } from '@ember/helper';
import Component from '@glimmer/component';

import type { SelectableListItem } from 'webapp/components/selectable-list';
import type { YieldedSettings } from 'webapp/components/selectable-list/row';

interface Args {
	item?: SelectableListItem;
	typedFilter?: string;
	isSelected?: boolean;
}

interface SelectableListLastRowComponentInterface {
	Args: Args;
	Blocks: {
		default: [settings: Partial<YieldedSettings>];
	};
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class SelectableListLastRowComponent extends Component<SelectableListLastRowComponentInterface> {
	<template>
		<li>
			{{yield (hash item=@item typedFilter=@typedFilter isSelected=@isSelected)}}
		</li>
	</template>
}
